/**
 * Cordova is ready and initiated
 */
export const GET_CHARGE_DATA = 'GET_CHARGE_DATA';
/**
 * Set past orders modal show flag.
 */
export const SET_PAST_ORDERS_SHOW = 'SET_PAST_ORDERS_SHOW';

export default {
  GET_ORDER_ID: GET_CHARGE_DATA,
  SET_PAST_ORDERS_SHOW,
};



// WEBPACK FOOTER //
// ./src/apps/kiosk/store/types.js